$(function() {
    const accordion = $(".accordion__list__item");
    const accordionToggle = accordion.find("header span");

    accordionToggle.on("click", function() {
        const clickedIndex = $(this).index(".accordion__list__item header span");
        
        if (!accordion.eq(clickedIndex).hasClass("open")) {

            $(accordion, "open").removeClass("open");
            $(accordion, "open").find("main").slideUp();

            accordion.eq(clickedIndex).addClass("open");
            accordion.eq(clickedIndex).find("main").slideDown({
                complete : function() {
                    if ($("section").hasClass("accordion__list")) {
                        $("html, body").animate({
                            scrollTop : (accordion.eq(clickedIndex).offset().top)
                        }, 300)
                    }
                }
            });

        } else {
            
            $(accordion, "open").removeClass("open");
            $(accordion, "open").find("main").slideUp();
        }
        
    })
})